module.exports = __webpack_public_path__ + "static/img/20230608_01.23faa40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230608_01.png
// module id = SiTe
// module chunks = 0